export default "__VITE_ASSET__BHY92PXW__"